import React from 'react';

export const actualAt = (arr, i) => (arr == null ? undefined : arr[i]);

export const ActualFragment = ({ value, format, title }) => {
  if (value === undefined) return null;
  return (
    <>
      <span className="fp-plan-actual" title={title}>
        {value === null ? '—' : format(value)}
      </span>
      <span className="fp-plan-actual-sep" aria-hidden="true">
        /
      </span>
    </>
  );
};
